export const getColorHex = (colorName: string): string => {
  if (!colorName) return '#CFCFCF';
  
  const normalized = colorName.trim().toLowerCase();
  
  const colorMap: Record<string, string> = {
    // Basic Colors
    'hitam': '#1E1E1E',
    'black': '#1E1E1E',
    'putih': '#F2F2F2',
    'white': '#F2F2F2',
    'broken white': '#F5F5DC',
    'ivory': '#FFFFF0',
    'silver': '#C0C0C0',
    'abu': '#808080',
    'gray': '#808080',
    'grey': '#808080',
    
    // Blues
    'navy': '#1A2421', // Dark navy/almost black based on typical fashion navies
    'biru': '#0000FF',
    'blue': '#0000FF',
    
    // Reds/Pinks
    'maroon': '#6A1B29', // Rich maroon
    'merah': '#FF0000',
    'red': '#FF0000',
    'burgundy': '#800020',
    'mahogany': '#4E070C', // Deep reddish brown
    'rose': '#FF007F',
    'nude pink': '#DDBEA9',
    'pale mauve': '#C6A4A4',
    
    // Greens
    'emerald': '#50C878',
    'hijau': '#008000',
    'green': '#008000',
    'moss green': '#8A9A5B',
    'light sage': '#C1C9BA',
    
    // Browns/Neutrals
    'cream': '#FDF4E3',
    'mocca': '#A38068',
    'stone': '#D6D3D1',
    'sweet taupe': '#A99A86',
    'biscuit': '#F4E2C6',
    'abu dusty': '#B0B0B0', // Dusty gray
    'dusty': '#C5A3A3',
    
    // Others
    'gold': '#FFD700',
    'orange': '#E98841',
    'kuning': '#FFFF00',
    'yellow': '#FFFF00',
    'charcoal': '#36454F',
  };

  return colorMap[normalized] || '#CFCFCF';
};
